/**
 * Whether a Sumsub `reviewAnswer` is a final answer (GREEN or RED). The API bills
 * a check on it and stops a late non-final result from overwriting it; the web
 * app treats it as the point where the verification is complete. One predicate,
 * so all three agree.
 */
export function isSumsubFinalAnswer(reviewAnswer: string | null | undefined): boolean {
  return reviewAnswer === "GREEN" || reviewAnswer === "RED";
}
